import React from 'react';
import Grid from '@material-ui/core/Grid';
import MDXParser from '../mdxParser';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemText from '@material-ui/core/ListItemText';
import Avatar from '@material-ui/core/Avatar';
import MapSvg from '../map';

// Content
import Map from '../../sections/Map/Map';
import MapSubtitle from '../../sections/Map/MapSubtitle';
import { Container } from '@material-ui/core';

import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import { withTheme } from '@material-ui/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: '60px 0',
      backgroundColor: '#0076bc',
    },
    container: {
      backgroundColor: '#0076bc',
    },
    rootDetail: {},
    text: {
      padding: '0px 20px',
      display: 'flex',
      backgroundColor: 'transparent',
      flexDirection: 'column',
      boxShadow: 'none',
      borderRadius: '0px',
    },
    image: {
      width: '100%',
      maxWidth: '100%',
      height: 'auto',
      objectFit: 'contain',
    },
    imageContainer: {
      backgroundColor: 'transparent',
      display: 'flex',
      flexDirection: 'column',
      boxShadow: 'none',
    },
    list: {
      [theme.breakpoints.up('sm')]: {
        flexDirection: 'row',
      },
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: 'white',
      padding: '20px',
    },
    listItem: {
      paddingLeft: '0px',
      color: 'black',
    },
    dgEcho: {
      backgroundColor: '#f47720',
      color: '#f47720',
    },
    dgDevco: {
      backgroundColor: '#833443',
      color: '#833443',
    },
    dgDevcoEcho: {
      backgroundColor: '#fcb715',
      color: '#fcb715',
    },
    dgNear: {
      backgroundColor: '#f0ba89',
      color: '#f0ba89',
    },
    dgNearEcho: {
      backgroundColor: '#034ea1',
      color: '#034ea1',
    },
    mapContainer: {
      minHeight: '600px',
      overflow: 'hidden',
    },
  }),
);

type Props = { children: React.ReactNode; image: string };

const MapSection = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Container>
        <Grid container spacing={3}>
          <Grid item xs={12} md={12} style={{ color: 'white', padding: '10px 0 30px 0' }}>
            <MDXParser color="white" borderColor="white">
              <Map />
            </MDXParser>
          </Grid>

          <Grid item xs={12} md={12} style={{ color: 'white', padding: '0px 0 40px 0' }}>
            <MDXParser color="white">
              <MapSubtitle />
            </MDXParser>
          </Grid>
        </Grid>
      </Container>
      <Container maxWidth={false} className={classes.container}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={12}>
            <List dense={true} className={classes.list}>
              <ListItem key={1} className={classes.listItem}>
                <ListItemAvatar>
                  <Avatar className={classes.dgEcho}></Avatar>
                </ListItemAvatar>
                <ListItemText primary="DG ECHO" />
              </ListItem>
              <ListItem key={2} className={classes.listItem}>
                <ListItemAvatar>
                  <Avatar className={classes.dgDevco}></Avatar>
                </ListItemAvatar>
                <ListItemText primary="DG DEVCO" />
              </ListItem>
              <ListItem key={3} className={classes.listItem}>
                <ListItemAvatar>
                  <Avatar className={classes.dgDevcoEcho}></Avatar>
                </ListItemAvatar>
                <ListItemText primary="DG DEVCO + ECHO" />
              </ListItem>
              <ListItem key={4} className={classes.listItem}>
                <ListItemAvatar>
                  <Avatar className={classes.dgNear}></Avatar>
                </ListItemAvatar>
                <ListItemText primary="DG NEAR" />
              </ListItem>
              <ListItem key={5} className={classes.listItem}>
                <ListItemAvatar>
                  <Avatar className={classes.dgNearEcho}></Avatar>
                </ListItemAvatar>
                <ListItemText primary="DG NEAR + ECHO" />
              </ListItem>
            </List>
          </Grid>
          <Grid item xs={12} md={12} className={classes.mapContainer}>
            <MapSvg />
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};

export default MapSection;
